import { render, staticRenderFns } from "./IconUnderline.vue?vue&type=template&id=1cf9418e&scoped=true"
import script from "./IconUnderline.vue?vue&type=script&lang=js"
export * from "./IconUnderline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf9418e",
  null
  
)

export default component.exports